export default __webpack_public_path__ + "static/media/cricket-quiz.adc1158c.jpg";